export interface SaveProspectDTO {
  advertId: string;
  prospectContactId: string;
  prospectStateId: number;
  manuallyAdded: boolean;
}
